import Vue from 'vue'
import Router from 'vue-router'
import storage from 'storejs'

const Home = () =>
  import('../page/home')
const IndexHome = () =>
  import('../page/home/page/indexHome')
const Guide = () =>
  import('../page/home/page/guide')
const Forward = () =>
  import('../page/home/page/forward')
const Course = () =>
  import('../page/home/page/course')
const SelfCollect = () =>
  import('../page/home/page/selfCollect')
const Case = () =>
  import('../page/home/page/case')

const VideoDetail = () =>
  import('../page/videoDetail');

const ArticleDetail = () =>
  import('../page/articleDetail')

const PptDetail = () =>
  import('../page/pptDetail')

const Search = () =>
  import('../page/search')

const searchPage = () =>
  import('../page/searchPage'); // 搜索页面

const Agree = () =>
  import('../page/agree')

const login = () =>
  import('../page/login/login')

const Xxkt = () =>
  import('../page/xxkt/xxkt') // 欣动例

const specialArea = () =>
  import('../page/home/page/specialArea') // 肾上献模块

const ssx = () =>
  import('../page/home/page/specialArea/ssx') // 肾上献模块

const sxgh = () =>
  import('../page/home/page/specialArea/sxgh') // 肾上献模块肾心共话

const sxqy = () =>
  import('../page/home/page/specialArea/sxqy') // 肾上献模块肾心前言栏目

const MeetingDetail = () =>
  import('../page/meetingDetail') // 会议详情


const self = () =>
  import('../page/login/self') // 个人中心

const setting = () =>
  import('../page/login/setting') // 信息编辑

const caseImg = () =>
  import('../page/caseImg')

const Comment = () =>
  import('../page/comment')

//欣享课堂模块
const ActivityVideo = () =>
  import('../page/activityVideo')

const Clear = () =>
  import('../page/clear')

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      component: Home,
      children: [{
          name: 'index-home',
          path: '',
          component: IndexHome
        },
        {
          path: '/home',
          component: IndexHome
        },
        {
          path: '/clear',
          component: Clear
        },
        {
          path: '/course',
          name: 'course',
          component: Course
        },
        {
          path: '/specialArea',
          name: 'specialArea',
          component: specialArea,
          meta: {
            open: true
          }
        },
        {
          path: '/xxkt',
          name: 'xxkt',
          component: Xxkt
        },
        {
          path: '/forward',
          name: 'forward',
          component: Forward
        },
        {
          path: '/case/:id',
          name: 'case',
          component: Case
        }
      ]
    },
    {
      path: '/activityVideo',
      name: 'activityVideo',
      component: ActivityVideo,
      meta: {
        open: true
      }
    },
    {
      path: '/guide',
      name: 'guide',
      component: Guide,
      meta: {
        open: true
      }
    },
    {
      path: '/videoDetail',
      name: 'videoDetail',
      component: VideoDetail,
      meta: {
        open: true
      }
    },
    {
      path: '/articleDetail',
      name: 'articleDetail',
      component: ArticleDetail,
      meta: {
        open: true
      }
    },
    {
      path: '/pptDetail',
      name: 'pptDetail',
      component: PptDetail,
      meta: {
        open: true
      }
    },
    {
      path: '/meetingDetail',
      name: 'meetingDetail',
      component: MeetingDetail,
      meta: {
        open: true
      }
    },
    {
      path: '/caseimg',
      component: caseImg,
      meta: {
        open: true
      }
    },
    {
      path: '/comment',
      name: 'comment',
      component: Comment,
      meta: {
        open: true
      }
    },
    {
      path: '/search',
      component: Search,
      meta: {
        open: true
      }
    },
    {
      path: '/agree',
      name: 'agree',
      component: Agree,
      meta: {
        open: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        open: true
      }
    },
    {
      path: '/self',
      name: 'self',
      component: self,
      meta: {
        open: true
      }
    },
    {
      path: '/searchPage',
      name: 'searchPage',
      component: searchPage,
      meta: {
        open: true
      }
    },

    {
      path: '/ssx',
      name: 'ssx',
      component: ssx,
      meta: {
        open: true
      }
    },
    {
      path: '/sxqy',
      name: 'sxqy',
      component: sxqy,
      meta: {
        open: true
      }
    },
    {
      path: '/sxgh',
      name: 'sxgh',
      component: sxgh,
      meta: {
        open: true
      }
    },
    {
      path: '/selfCollect',
      name: 'selfCollect',
      component: SelfCollect
    },

    // {
    //   path: '/setting',
    //   name: 'setting',
    //   component: setting,
    //   meta: { open: true }
    // }



  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js